import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';
import { ArrowRight, Lock, Mail } from 'lucide-react';
import BrandLogo from '../components/BrandLogo';
import { SUPPLIERS_BETA_ENABLED } from '../lib/featureFlags';

const BACKEND_URL =
  window.location.hostname.endsWith('trycloudflare.com')
    ? window.location.origin
    : (process.env.REACT_APP_BACKEND_URL || window.location.origin);

const API = `${BACKEND_URL}/api`;

export default function SupplierLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      await axios.post(
        `${API}/suppliers/login`,
        { email: email.trim().toLowerCase(), password },
        { withCredentials: true }
      );
      toast.success('Bem-vindo(a) à área de fornecedores.');
      navigate('/fornecedor/painel');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao entrar no portal.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F6F1EF] flex items-center justify-center p-6">
      <div className="w-full max-w-md rounded-[2rem] border border-[#E8B7B1]/35 bg-white p-8 shadow-[0_30px_80px_rgba(96,72,58,0.12)]">
        <div className="text-center mb-8">
          <Link to="/" className="mb-6 inline-flex items-center gap-2">
            <BrandLogo size="sm" />
          </Link>
          <h1 className="text-3xl font-bold text-[#1C1C1C]" style={{ fontFamily: 'Playfair Display' }}>
            Area de Fornecedores
          </h1>
          <p className="mt-2 text-[#5B4A45]">
            Acesse seu painel para editar seu perfil, acompanhar aprovação e gerenciar sua divulgação.
          </p>
          {SUPPLIERS_BETA_ENABLED ? (
            <p className="mt-3 inline-flex rounded-full border border-[#E8B7B1]/45 bg-[#FDF6F3] px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#C8A97E]">
              Area de fornecedores
            </p>
          ) : null}
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <Label className="mb-2 block text-sm font-bold uppercase tracking-wider text-[#1C1C1C]">E-mail</Label>
            <div className="relative">
              <Mail className="absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-[#7E6A64]" />
              <Input
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="parceiro@empresa.com"
                autoComplete="email"
                className="h-12 rounded-xl border-[#E8B7B1]/35 bg-[#F9F5F3] pl-12"
                required
                data-testid="supplier-login-email"
              />
            </div>
          </div>

          <div>
            <Label className="mb-2 block text-sm font-bold uppercase tracking-wider text-[#1C1C1C]">Senha</Label>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-[#7E6A64]" />
              <Input
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="Digite sua senha"
                autoComplete="current-password"
                className="h-12 rounded-xl border-[#E8B7B1]/35 bg-[#F9F5F3] pl-12"
                required
                data-testid="supplier-login-password"
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="h-12 w-full rounded-full bg-[#E8B7B1] text-white hover:bg-[#DFA8A1]"
            data-testid="supplier-login-btn"
          >
            {loading ? 'Entrando...' : (
              <span className="inline-flex items-center gap-2">
                Entrar no portal <ArrowRight className="h-5 w-5" />
              </span>
            )}
          </Button>
        </form>

        <p className="mt-6 text-center text-sm text-[#5B4A45]">
          Ainda não tem cadastro?{' '}
          <Link to="/fornecedor/cadastro" className="font-semibold text-[#1C1C1C] hover:underline">
            Criar perfil de fornecedor
          </Link>
        </p>
      </div>
    </div>
  );
}


